import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { Collapse, Grid } from "antd";
import LoadingContent from "../../common/LoadingContent";
import PageTitleNoAdd from "../../components/header/PageTitleNoAdd";
import axiosWithAuth from "../../utils/axiosWithAuth";

import OrderTaxRows from "../../common/OrderTaxRows";
import OrderTipRow from "../../common/OrderTipRow";

import useOrderTaxSummary from "../../hooks/useOrderTaxSummary";

export default function OrderConfirmationPage() {
  const { id } = useParams();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { Panel } = Collapse;

  const [orderData, setOrderData] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const taxSummary = useOrderTaxSummary(orderData);

  useEffect(() => {
    const APIURL = `/api/orders/${id}`;

    axiosWithAuth()
      .get(APIURL)
      .then((res) => {
        setOrderData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
      });
  }, [id]);

  return (
    <div id="order-confirmation">
      <Helmet>
        <title>BIZZLL - Order Confirmation</title>
      </Helmet>

      <PageTitleNoAdd pageTitle="Order Confirmation" />

      <div className="page-wrapper">
        {loading ? (
          <LoadingContent />
        ) : (
          <div className="inner-container">
            <div className="header">
              <h2>Thank you for your order!</h2>

              <h3>Order Number: {orderData.id}</h3>
            </div>

            <div className="order-details">
              <h3>Order Details</h3>

              {screens.lg ? (
                <div className="products-table">
                  <div className="row labels">
                    <div className="item">Item</div>
                    <div className="price">Price</div>
                    <div className="quantity">Quantity</div>
                    <div className="total">Total</div>
                  </div>

                  {orderData.orderItems.map((item) => {
                    let productName;
                    let productDescription;
                    const itemPrice = item.price / item.quantity;

                    if (item.type === "event_ticket") {
                      productName = item.ticket.event_name;
                      productDescription = item.ticket.ticket_name;
                    } else if (item.type === "service_product") {
                      productName = item.appointment.name;
                      productDescription = "Reserved a time block";
                    }

                    return (
                      <div className="row items" key={item.id}>
                        <div className="item">
                          {productName}
                          <span>{productDescription}</span>
                        </div>
                        <div className="price">${itemPrice.toFixed(2)}</div>
                        <div className="quantity">{item.quantity}</div>
                        <div className="total">${item.price.toFixed(2)}</div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Collapse accordion>
                  {orderData.orderItems.map((item) => {
                    let productName;
                    let productDescription;
                    const itemPrice = item.price / item.quantity;

                    if (item.type === "event_ticket") {
                      productName = item.ticket.event_name;
                      productDescription = item.ticket.ticket_name;
                    } else if (item.type === "service_product") {
                      productName = item.appointment.name;
                      productDescription = "Reserved a time block";
                    }

                    return (
                      <Panel
                        key={item.id}
                        header={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span>
                              <strong>{productName}</strong>
                            </span>
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              ${item.price.toFixed(2)}
                            </span>
                          </div>
                        }
                      >
                        <p>
                          <strong>Item:</strong> {productName}
                        </p>
                        <p>
                          <strong>Description:</strong> {productDescription}
                        </p>
                        <p>
                          <strong>Price:</strong> ${itemPrice.toFixed(2)}
                        </p>
                        <p>
                          <strong>Quantity:</strong> {item.quantity}
                        </p>
                        <p>
                          <strong>Total:</strong> ${item.price.toFixed(2)}
                        </p>
                      </Panel>
                    );
                  })}
                </Collapse>
              )}

              <div
                className="order-summary"
                style={{
                  marginTop: "30px",
                  padding: "20px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "10px",
                  border: "1px solid #e0e0e0",
                }}
              >
                <OrderTaxRows summary={taxSummary} />
                <OrderTipRow tip={taxSummary.tip} />
                <div
                  className="summary-row total-row"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "15px 0 5px 0",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  <span className="label" style={{ color: "#c63627" }}>
                    Total:
                  </span>
                  <span className="value" style={{ color: "#c63627" }}>
                    ${taxSummary.total?.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {error !== "" && (
          <div className="inner-container">
            <div className="header">
              <h2>There was an error retrieving order</h2>

              <h3>{error}</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
